// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import axiosInstance, {socketURL } from "../axiosInstance";
import getDecryptData from "../helpers/getDecryptData";
import getCookie from "../helpers/getCookie";
import eraseCookie from "../helpers/eraseCookie";
import io from "socket.io-client";

const socket = io(socketURL);

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [getAuth, setAuth] = useState([]);

    const [VideoAllCall, setVideoAllCall] = useState([]);


  const dataAuth = async () => {
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;

    const credentials = {
      id: id,
    };
    const authuser = getCookie("token");
    if (!authuser) {
      return;
    }

    try {
 
      const { data } = await axiosInstance.post("/auth-user", credentials);

      const { success, existingUser,calls } = data;
      if (success) {
        console.log(existingUser.type);
        setVideoAllCall(existingUser.calls);
        return existingUser;
      } else if (data.success === false) {
        toast.error(data.message);
        eraseCookie("token");
      }

    } catch (error) {
      console.log(error);
    }
  };

  const [allMessages, setAllMessages] = useState([]);

   const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: "long", // Use 'long' to display the full month name
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  
  useEffect(() => {
 

    socket.on("chat message", (message) => {
      console.log("messagemessagemessagemessage", message);
      if (message.type === "message") {
        console.log("get message");
        // Add date and time to the message object before updating state
        const messageWithDateTime = {
          ...message,
          time: formatTimestamp(new Date()),
        };

        setAllMessages((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
        // if (message.userId !== userId) {
        //     playMessageAlert(); // Play sound alert if the message sender is the current user

        //    }
      }
    
      // if (message.type === "location") {
      //   const messageWithDateTime = { ...message };
      //   setLocationReq((prevMessages) => {
      //     const newMessages = [...prevMessages, messageWithDateTime];
      //     return newMessages;
      //   });
      // }
  

    });

    return () => {
      socket.off("chat message");
    };
  }, []);



  useEffect(() => {
    dataAuth();
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        getAuth,
        socket,
        VideoAllCall
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};
